module.exports = __webpack_public_path__ + "assets/asset_anchor.4c212719.svg";